/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export enum Ownership {
  LABS = 'labs',
  PANEL_VALUE = 'panel_value',
  RESEARCH_EXPERIENCE = 'research_experience',
  DESIGN_SYSTEM = 'design_system',
  ENTERPRISE_PLATFORM = 'enterprise_platform',
}

